module.exports = __webpack_public_path__ + "img/aniversario_fast.518f6ed5.jpg";